import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { Element } from '../../html/element'
import classes from './index.module.scss'

const HEIGHT_EXAMPLE_HEXAGON = 120
const WIDTH_EXAMPLE_HEXAGON = 104

const Hexagon = ({ color, title, value }) => {
  const ref = useRef()

  const [ratio, setRatio] = useState()

  useEffect(() => {
    if (!ratio) {
      resize()
    }
  }, [ratio])

  useEffect(() => {
    window.addEventListener('resize', resize)
    return () => window.removeEventListener('resize', resize)
  }, [])

  const resize = () => {
    setRatio(
      Math.min(
        ref.current.offsetWidth / WIDTH_EXAMPLE_HEXAGON,
        ref.current.offsetHeight / HEIGHT_EXAMPLE_HEXAGON,
      ),
    )
  }

  return (
    <div ref={ref} className={classes.hexagon}>
      <div className="positionRelative wFitContent">
        <div
          style={{
            borderBottom: `${30 * ratio}px solid ${color}`,
            borderLeft: `${52 * ratio}px solid transparent`,
            borderRight: `${52 * ratio}px solid transparent`,
          }}
          className={classes.topTriangle}
        />
        <div
          style={{
            borderLeft: `${4 * ratio}px solid ${color}`,
            borderRight: `${4 * ratio}px solid ${color}`,
            borderBottom: `${2 * ratio}px solid ${color}`,
            borderTop: `${22 * ratio}px solid ${color}`,
            width: `${104 * ratio}px`,
            height: `${60 * ratio}px`,
            backgroundColor: '#ffffff',
          }}
        />
        <div
          style={{
            borderTop: `${30 * ratio}px solid ${color}`,
            borderLeft: `${52 * ratio}px solid transparent`,
            borderRight: `${52 * ratio}px solid transparent`,
          }}
          className={classes.bottomTriangle}
        >
          <div
            style={{
              top: `${-32 * ratio}px`,
              left: `${-48 * ratio}px`,
              borderTop: `${27 * ratio}px solid #FFFFFF`,
              borderLeft: `${48 * ratio}px solid transparent`,
              borderRight: `${48 * ratio}px solid transparent`,
            }}
            className={classes.background}
          />
        </div>
        {title && (
          <Element style={{ color: '#FFFFFF' }} className={classes.title}>
            {title}
          </Element>
        )}
        {value && (
          <Element
            style={{ color: color, fontSize: 20 }}
            className={classes.value}
          >
            {value}
          </Element>
        )}
      </div>
    </div>
  )
}

Hexagon.propTypes = {
  color: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string,
}

Hexagon.defaultProps = {
  color: 'red',
}

export default Hexagon
